import { useMutation } from '@tanstack/react-query'
import { sendBulkAnnualReports } from '../utils/sendBulkAnnualReports'
import type { SendBulkAnnualReportsRequest } from '@/features/receipts/api/receiptsApi'

export const useSendBulkAnnualReportsMutation = () => {
  return useMutation({
    mutationFn: (params: SendBulkAnnualReportsRequest) =>
      sendBulkAnnualReports(params),
    onError: (error) => {
      console.error('Error sending bulk annual reports:', error)
    },
  })
}
